import { render, staticRenderFns } from "./disease_chart.vue?vue&type=template&id=2ce48ac4&scoped=true"
import script from "./disease_chart.vue?vue&type=script&lang=js"
export * from "./disease_chart.vue?vue&type=script&lang=js"
import style0 from "./disease_chart.vue?vue&type=style&index=0&id=2ce48ac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce48ac4",
  null
  
)

export default component.exports